import app from './app';
import auth from './auth';
import expert from './expert';
import user from './user';

export default { app, auth, expert, user };
